module.exports = __webpack_public_path__ + "img/interrogation-point.3648e6d3.png";